<template>
  <div class="login-container">
    <el-row>
      <el-col :xs="24" class="login-nav">
        <todo-logo class="login-logo" />

        <el-form ref="signInForm" :model="form" :rules="rules" class="login-form">
          <h1>{{ $t('auth.logIn') }}</h1>
          <el-form-item :label="$t('email')" prop="email">
            <el-input v-model="form.email" type="text" autocomplete="off" autofocus
                      @keyup.enter.native="submitForm"
            />
          </el-form-item>
          <el-form-item :label="$t('password')" prop="password">
            <el-input v-model="form.password" type="password" autocomplete="off"
                      @keyup.enter.native="submitForm"
            />
          </el-form-item>
        </el-form>

        <div class="login-button">
          <el-button type="warning" round @click="submitForm">
            {{ $t('auth.logIn') }}
          </el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        form: {
          email: '',
          password: ''
        },
        rules: {
          email: [
            { validator: this.validateEmail, trigger: 'blur' }
          ],
          password: [
            { validator: this.validatePassword, trigger: 'blur' }
          ]
        }
      }
    },

    methods: {
      submitForm() {
        this.resetValidation()

        this.$refs.signInForm.validate(valid => {
          if (valid) this.signIn()
        })
      },

      signIn() {
        this.$store.dispatch('Auth/login', this.form)
          .then(() => this.$router.push('/dashboard'))
          .catch(() => {
            //
          })
      },

      resetValidation() {
        this.$refs.signInForm.clearValidate()
      },

      validateEmail(rule, value, callback) {
        if (value === '') {
          callback(new Error(this.$t('auth.errors.email')))
        } else {
          callback()
        }
      },

      validatePassword(rule, value, callback) {
        if (value === '') {
          callback(new Error(this.$t('auth.errors.password')))
        } else {
          callback()
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/variables';

  .login-container {
    z-index: 1;
    position: relative;
    height: 100%;
    background-color: $color-background;

    .el-row {
      height: 100%;

      .el-col {
        height: 100%;
      }
    }

    .login-nav {
      position: relative;
      max-width: 455px;
      background: white;
    }

    .login-logo {
      position: absolute;
      width: 200px;
      height: 40px;
      margin: auto;
      top: 7%;
      left: 0;
      right: 0;
      color: $color-blue;

      .logo {
        font-size: 23px;
        line-height: 33px;
      }
    }

    .login-form {
      position: absolute;
      width: 270px;
      height: 250px;
      margin: auto;
      top: 30%;
      left: 0;
      right: 0;

      h1 {
        font-weight: bold;
        font-size: 32px;
        line-height: 51px;
        color: #354C9D;
        margin-bottom: 35px;
      }
    }

    .login-button {
      position: absolute;
      bottom: 79px;
      width: 257px;
      margin: auto;
      left: 0;
      right: 0;
    }
  }
</style>
